export const ACCESS_TOKEN_NAME = "access_token";
export const REFRESH_TOKEN_NAME = "refresh_token";
export const USER_DETAIL = "user";
export const DOMAIN = "dominio";
export const TYPE = "user_type";
export const ADD_REGISTER = "form_permissions_add_register";
export const EDIT_REGISTER = "form_permissions_edit_register";
export const VIEW_REGISTER = "form_permissions_view_register";
export const UPLOAD_FILES = "form_permissions_upload_files";
export const CREATE_EXPEDIENT = "form_permissions_create_expedient";
export const SET_PATH_EXPEDIENT = "form_permissions_set_path_expedient";
export const DELETE_PATH_EXPEDIENT = "form_permissions_delete_path_expedient";
export const VIEW_FILES = "form_permissions_view_files";
export const EDIT_FILE_DATA = "form_permissions_edit_file_data";
export const MOVE_FILE = "form_permissions_move_file";
export const MOVE_FILE_TO_TRASH = "form_permissions_move_file_to_trash";
export const SIGN_ELECTRONICALLY = "form_permissions_sign_electronically";
export const VIRTUAL_TOKEN_PKI = "form_permissions_virtualTokenPki";
export const NOTIFICATIONS = "form_permissions_notifications";
export const CANCEL_RECORD = "form_permissions_cancel_record";
export const ADD_WORKFLOW = "form_permissions_add_workflow";
export const VIEW_WORKFLOW = "form_permissions_view_workflow";
export const INTEGRATIONS = "integrations_option";
export const ROLES_PERMISSIONS = "roles_permissions";
export const DESIGNER_FORMS_PERMISSIONS = "designer_forms_permissions";
export const DESIGNER_FORMS = "designer_forms";
export const PASSWORD_EXPIRATION_DAYS = "password_expiration_days";
export const LIMIT_EXPIRATION_DAY = "0";
export const WORKFLOW_FORMS_PERMISSIONS = "workflow_forms_permissions";
export const WORKFLOW_ALL_FORMS = "workflow_all_forms";
export const FIRST_EXECUTION_BOOLEAN = "firs_execution_boolean";
export const SUBMENU_EXPEDIENT_CONSULT_BOOLEAN = "submenu_expedient_consult_boolean";
export const QUERY_FILTER = "query_filter";
export const QUERY_FIELDS = "query_fields";
export const DATA_RECORD_LOOKUP = "data_record_lookup";
export const QUERY_TABLE = "query_table";
export const ADDITIONAL_SERVICES = "additional_services";
export const USER_LANGUAGE = "user_language";

export const KEYS_GENERATE = {
  [ACCESS_TOKEN_NAME]: "KEY_01",
  [TYPE]: "KEY_02",
  [DESIGNER_FORMS]: "KEY_03",
  [DOMAIN]: "KEY_04",
  [USER_DETAIL]: "KEY_05",
  [ADD_REGISTER]: "KEY_06",
  [EDIT_REGISTER]: "KEY_07",
  [VIEW_REGISTER]: "KEY_08",
  [UPLOAD_FILES]: "KEY_09",
  [CREATE_EXPEDIENT]: "KEY_10",
  [SET_PATH_EXPEDIENT]: "KEY_11",
  [DELETE_PATH_EXPEDIENT]: "KEY_12",
  [VIEW_FILES]: "KEY_13",
  [EDIT_FILE_DATA]: "KEY_14",
  [MOVE_FILE]: "KEY_15",
  [MOVE_FILE_TO_TRASH]: "KEY_16",
  [SIGN_ELECTRONICALLY]: "KEY_17",
  [NOTIFICATIONS]: "KEY_18",
  [CANCEL_RECORD]: "KEY_19",
  [ADD_WORKFLOW]: "KEY_20",
  [VIEW_WORKFLOW]: "KEY_21",
  [INTEGRATIONS]: "KEY_22",
  [ROLES_PERMISSIONS]: "KEY_23",
  [DESIGNER_FORMS_PERMISSIONS]: "KEY_24",
  [PASSWORD_EXPIRATION_DAYS]: "KEY_25",
  [LIMIT_EXPIRATION_DAY]: "KEY_26",
  [WORKFLOW_FORMS_PERMISSIONS]: "KEY_27",
  [WORKFLOW_ALL_FORMS]: "KEY_28",
  [FIRST_EXECUTION_BOOLEAN]: "KEY_29",
  [SUBMENU_EXPEDIENT_CONSULT_BOOLEAN]: "KEY_30",
  [QUERY_FILTER]: "KEY_31",
  [QUERY_FIELDS]: "KEY_32",
  [DATA_RECORD_LOOKUP]: "KEY_33",
  [QUERY_TABLE]: "KEY_34",
  [ADDITIONAL_SERVICES]: "KEY_36",
  [USER_LANGUAGE]: "KEY_37",
};
